export const PROMO_CODE_ROUTE_NAMES = {
  PROMO_CODE_LIST: 'promoCodeList',
  PROMO_CODE_EDIT: 'promoCodeEdit',
}
